import { useManagers } from './useManagers';

interface UseOperatorOptions {
  id: string | null | undefined;
}

interface UseOperatorReturn {
  operator: { id: string; name: string } | undefined;
  isLoading: boolean;
  error: Error | undefined;
}

/**
 * 단일 매니저(Operator) 조회 훅
 */
export function useOperator({ id }: UseOperatorOptions): UseOperatorReturn {
  const { managers, isLoading, error } = useManagers({
    ids: id ? [id] : [],
  });

  return {
    operator: managers[0],
    isLoading,
    error,
  };
}
